import OsqueryTable from './OsqueryTable'

export default OsqueryTable
